import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ToastService } from '../../shared/toast/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent {
  form: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  async onSubmit() {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    const { email, password } = this.form.value;
    try {
      await this.auth.login(email, password);
      const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') ?? '/sites';
      this.router.navigateByUrl(returnUrl);
    } catch (err: any) {
      this.toast.error(this.describeError(err));
    } finally {
      this.isSubmitting = false;
    }
  }

  private describeError(err: any): string {
    const code = err?.code || err?.name;
    if (code === 'NotAuthorizedException') return 'Incorrect email or password.';
    if (code === 'UserNotFoundException') return 'Incorrect email or password.';
    if (code === 'UserNotConfirmedException')
      return 'This account has not been confirmed. Please check your invite email.';
    return err?.message || 'Sign in failed. Please try again.';
  }
}
